import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { DialogService, SelectFieldOption, TranslationService } from '@sdbn/common';
import { TransportOptionsAdministrationContext } from '../../transport-options-administration.context';
import { EditableTransportOptionConstraint, TransportOption, TransportOptionConstraint, TransportOptionConstraintType } from '../../transport-options.model';
import { MasterDetailListEntry } from '@sdbn/common';

@Component({
    selector: 'app-transport-option-constraints-editor',
    templateUrl: './transport-option-constraints-editor.component.html',
    styleUrls: ['./transport-option-constraints-editor.component.scss'],
    standalone: false
})
export class TransportOptionConstraintsEditorComponent implements OnInit {

  newConstraintId = -1;

  assignedOptions = new Array<TransportOption>();

  // constraintTypes = new Array<TransportOptionConstraintType>();

  detailsFormGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    count: new FormControl(null, [Validators.required, Validators.min(0)]),
    type: new FormControl(null, [Validators.required])
  });

  selectedConstraint: TransportOptionConstraint = null;

  private eventSource = 'transport-option-constraints-editor';

  saveEnabled = true;

  cancelEnabled = true;

  context: TransportOptionsAdministrationContext;
  contextSubscription: Subscription;

  constraintTypeOptions = [
    new SelectFieldOption({ value: TransportOptionConstraintType.MAX_SELECTED_COUNT, labelDictionaryKey: 'tmc-yard.entity.transport-option-constraint.type.' + TransportOptionConstraintType.MAX_SELECTED_COUNT }),
    new SelectFieldOption({ value: TransportOptionConstraintType.MIN_SELECTED_COUNT, labelDictionaryKey: 'tmc-yard.entity.transport-option-constraint.type.' + TransportOptionConstraintType.MIN_SELECTED_COUNT })
  ];

  @Input() set optionsContext(optionsContext: TransportOptionsAdministrationContext) {
    this.context = optionsContext;
    this.resoreSelection();

    if (this.contextSubscription != null) {
      this.contextSubscription.unsubscribe();
    }
    if (this.context != null) {
      this.contextSubscription = this.context.contextChange$.subscribe(
        change => {
          if (change.source !== this.eventSource && change.key === 'options-changed') {
          }
          if (change.source !== this.eventSource && change.key === 'constraints-changed') {
            this.resoreSelection();
          }
        }
      );
    }
  }

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) {

    // for (const key of Object.keys(TransportOptionConstraintType)) {
    //   this.constraintTypes.push(TransportOptionConstraintType[key]);
    // }




  }

  ngOnInit(): void {

    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty && this.selectedConstraint != null) {
          this.selectedConstraint.name = this.detailsFormGroup.controls.name.value;
          this.selectedConstraint.count = this.detailsFormGroup.controls.count.value == null ||
            this.detailsFormGroup.controls.count.value.legth === 0 ? null : +this.detailsFormGroup.controls.count.value;
          this.selectedConstraint.type = this.detailsFormGroup.controls.type.value;
          this.context.dirty = true;
          this.context.validateConstraints();
        }
      }
    );

  }

  public clearSelection() {
    this.selectedConstraint = null;
    this.context.selectedConstraint = null;
    this.assignedOptions = new Array<TransportOption>();
    this.detailsFormGroup.reset({});
  }

  public setSelectedConstraint(constraint: EditableTransportOptionConstraint) {
    if (constraint != null) {
      this.selectedConstraint = constraint;
      this.context.selectedConstraint = constraint;

      const values: any = {};
      values.name = this.selectedConstraint?.name;
      values.count = this.selectedConstraint?.count;
      values.type = this.selectedConstraint?.type;

      console.log('setting value', values);

      const assignedOptions = new Array<TransportOption>();
      for (const option of this.context.options) {
        if (this.selectedConstraint.transportOptionIds.indexOf(option.id) >= 0) {
          assignedOptions.push(option);
        }
      }
      this.assignedOptions = assignedOptions;
      this.detailsFormGroup.reset(values);
    } else {
      this.clearSelection();
    }
  }

  public onAssignedOptionsChanged(assignedOptions = new Array<TransportOption>()) {
    if (this.selectedConstraint != null) {
      this.selectedConstraint.transportOptionIds = assignedOptions.map(o => o.id);
      this.context.dirty = true;
      this.context.validateConstraints();
    }
  }

  public addConstraint() {
    const newConstraint = new EditableTransportOptionConstraint({
      id: this.newConstraintId--, type: TransportOptionConstraintType.MIN_SELECTED_COUNT
    });
    this.setSelectedConstraint(newConstraint);
    this.context.constraints.push(newConstraint);
    this.context.dirty = true;
    this.context.validateConstraints();
  }

  private resoreSelection() {
    const selected = this.context.constraints.find(c => c.id === this.context.selectedConstraint?.id);
    if (selected != null) {
      this.setSelectedConstraint(selected);
    } else {
      this.setSelectedConstraint(this.context.constraints[0]);
    }
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.setSelectedConstraint(entry as EditableTransportOptionConstraint);
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    this.addConstraint();
  }

  onDeleteEntry(entry: MasterDetailListEntry) {

    const constraint = entry as EditableTransportOptionConstraint;


    this.dialogService.showConfirm(
      'tmc-yard.service.admin.transport-option-administration.transport-option-constraints-editor.delete.confirm-dialog.title',
      'tmc-yard.service.admin.transport-option-administration.transport-option-constraints-editor.delete.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.context.constraints.splice(this.context.constraints.findIndex(c => c.id === constraint.id), 1);
        if (constraint.id > 0) {
          constraint.deleted = true;
          this.context.addDeletedConstraint(constraint);
        }
        this.setSelectedConstraint(this.context.constraints[0]);
        this.context.dirty = true;
      }
    });

  }

}
